// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resultPage_main__TEQqX {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    overflow-y: visible;
    box-sizing: border-box;
    overflow: hidden;
}

.resultPage_main__TEQqX h1 {
    font-family: "Inter", sans-serif !important;
    font-weight: 700;
    font-size: 50px;
}
.resultPage_main__TEQqX h2 {
    font-weight: 700;
    font-size: 54px;
    margin-top: 40px;
}
.resultPage_main__TEQqX h3 {
    font-family: "Inter", sans-serif !important;
    font-weight: 600;
    font-size: 36px;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
}

.resultPage_topStripe__fe8c5 {
    position: absolute;
    width: 1204px;
    height: 872px;
    left: 0;
    top: 0;
}

.resultPage_rightStripe__zkcux {
    position: absolute;
    width: 1204px;
    height: 872.01px;
    top: 1000px;
    right: -50px;
}

.resultPage_shareButton__K\\+mKz {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 700px;
    justify-content: baseline;
}

.resultPage_shareButton__K\\+mKz button {
    display: flex;
    align-items: flex-end;
    width: 50%;
    max-width: 400px;
    border-radius: 8px;
    background-color: transparent;
    outline: none;
    border: none;
    color: #B3B3B3;
    font-weight: 700;
    font-size: 24px !important;
    margin-top: 20px;
    cursor: pointer;
}

.resultPage_buttonIcon__eLj1B {
    color: #B3B3B3;
    margin-top: 10px;
    width: 40px;
    margin-right: 10px;
}

.resultPage_shareButton__K\\+mKz button:disabled { background: #867e7e; color: #ececec; }

@media screen and (max-width: 960px) {
    .resultPage_topStripe__fe8c5 {
        width: 83%;
        height: auto;
    }
    .resultPage_rightStripe__zkcux {
        width: 60%;
        right: 0px;
        height: auto;
    }

    .resultPage_shareButton__K\\+mKz button {
        width: 50%;
        margin-top: 10px;
        font-size: 14px !important;
    }

    .resultPage_buttonIcon__eLj1B {
        margin-top: 10px;
        margin-left: 70px;
        width: 35px;
    }

    .resultPage_main__TEQqX h1 {
        font-size: 9vw;
    }
    .resultPage_main__TEQqX h2 {
        font-size: 6vw;
        margin-top: 30px;
    }
    .resultPage_main__TEQqX h3 {
        font-size: 40px;
    }
    .resultPage_main__TEQqX h4 {
        font-size: 5vw;
        width: 90%;
    }
}

.resultPage_table__5G8m6 {
    width: 50%;
    margin-top: 20px;
    box-sizing: border-box;
    min-width: 625px;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: 30px calc(10px + 1vw);
}

.resultPage_firstLi__qSW94 {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.resultPage_bodyLi__98wsG {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 1px solid #000;
}
.resultPage_firstColumn__yO1CY {
    min-width: 268px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 50%;
    border-right: 1px solid #000;
    padding: 20px 0;
    font-size: 24px;
}
.resultPage_secondColumn__bat1B {
    min-width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    border-right: 1px solid #000;
    padding: 20px 0;
    font-size: 24px;
}
.resultPage_thirdColumn__tHZNp {
    min-width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    padding: 20px 0;
    font-size: 24px;
}
.resultPage_bottomPar__8REit {
    font-size: 28px;
    line-height: 1.6;
    text-align: center;
    color: #000;
    font-weight: 300;
    margin-top: 100px;
}

@media screen and (max-width: 960px) {
    .resultPage_table__5G8m6 {
        width: 90%;
        min-width: 350px;
    }
    .resultPage_firstColumn__yO1CY, .resultPage_secondColumn__bat1B, .resultPage_thirdColumn__tHZNp {
        font-size: 12px;
        padding: 13px 0;
        min-width: 0;
    }
    .resultPage_bottomPar__8REit {
        font-size: 18px;
        margin-top: 40px;
        padding: 0 16px;
    }
}
.resultPage_table__5G8m6 ul {
    width: 100%;
}
.resultPage_table__5G8m6 ul li {
    width: 100%;
}
.resultPage_table_first__uTSEl {
    width: 100%;
}



.resultPage_belbinLabel__htLa7 {
    display: block;
    margin-top: 160px;
    margin-bottom: 50px;
    padding-bottom: 200px;
    height: 150px;
}

.resultPage_belbinLabel__htLa7 img {   
    height: 80px;
}

/*
.belbinLabel {
    margin-top: 150px;
    margin-bottom: 50px;
    transform: rotate(-6deg);
    background: url(../../assets/ResultPage/belbinLabel.svg) bottom center;
}

*/

@media screen and (max-width: 960px) {
    .resultPage_belbinLabel__htLa7 {
        margin-top: 100px;
        margin-bottom: 30px;
    }

    .resultPage_belbinLabel__htLa7 img {   
        height: 40px;
    }

}
@media screen and (max-width: 600px) {
    .resultPage_belbinLabel__htLa7 {
        margin-top: 70px;
        margin-bottom: 20px;
    }

    .resultPage_belbinLabel__htLa7 img {   
        height: 30px;
    }

    .resultPage_shareButton__K\\+mKz button {
        width: 80% !important;
        margin-top: 5px;
        font-size: 18px !important;
    }

    .resultPage_buttonIcon__eLj1B {
        margin-right: 10px;
        margin-top: 0px;
        width: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ResultPage/resultPage.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,OAAO;IACP,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA,kDAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE;IACI;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,UAAU;QACV,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;IACA;QACI,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,4BAA4B;IAC5B,eAAe;IACf,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,4BAA4B;IAC5B,eAAe;IACf,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;AACJ;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;;;AAIA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;;;CAQC;;AAED;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;AAEJ;AACA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;IACf;AACJ","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 80px;\n    overflow-y: visible;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n\n.main h1 {\n    font-family: \"Inter\", sans-serif !important;\n    font-weight: 700;\n    font-size: 50px;\n}\n.main h2 {\n    font-weight: 700;\n    font-size: 54px;\n    margin-top: 40px;\n}\n.main h3 {\n    font-family: \"Inter\", sans-serif !important;\n    font-weight: 600;\n    font-size: 36px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    text-align: center;\n}\n\n.topStripe {\n    position: absolute;\n    width: 1204px;\n    height: 872px;\n    left: 0;\n    top: 0;\n}\n\n.rightStripe {\n    position: absolute;\n    width: 1204px;\n    height: 872.01px;\n    top: 1000px;\n    right: -50px;\n}\n\n.shareButton {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    max-width: 700px;\n    justify-content: baseline;\n}\n\n.shareButton button {\n    display: flex;\n    align-items: flex-end;\n    width: 50%;\n    max-width: 400px;\n    border-radius: 8px;\n    background-color: transparent;\n    outline: none;\n    border: none;\n    color: #B3B3B3;\n    font-weight: 700;\n    font-size: 24px !important;\n    margin-top: 20px;\n    cursor: pointer;\n}\n\n.buttonIcon {\n    color: #B3B3B3;\n    margin-top: 10px;\n    width: 40px;\n    margin-right: 10px;\n}\n\n.shareButton button:disabled { background: #867e7e; color: #ececec; }\n\n@media screen and (max-width: 960px) {\n    .topStripe {\n        width: 83%;\n        height: auto;\n    }\n    .rightStripe {\n        width: 60%;\n        right: 0px;\n        height: auto;\n    }\n\n    .shareButton button {\n        width: 50%;\n        margin-top: 10px;\n        font-size: 14px !important;\n    }\n\n    .buttonIcon {\n        margin-top: 10px;\n        margin-left: 70px;\n        width: 35px;\n    }\n\n    .main h1 {\n        font-size: 9vw;\n    }\n    .main h2 {\n        font-size: 6vw;\n        margin-top: 30px;\n    }\n    .main h3 {\n        font-size: 40px;\n    }\n    .main h4 {\n        font-size: 5vw;\n        width: 90%;\n    }\n}\n\n.table {\n    width: 50%;\n    margin-top: 20px;\n    box-sizing: border-box;\n    min-width: 625px;\n    background-color: #fff;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    padding: 30px calc(10px + 1vw);\n}\n\n.firstLi {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n.bodyLi {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border-top: 1px solid #000;\n}\n.firstColumn {\n    min-width: 268px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 50%;\n    border-right: 1px solid #000;\n    padding: 20px 0;\n    font-size: 24px;\n}\n.secondColumn {\n    min-width: 150px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 25%;\n    border-right: 1px solid #000;\n    padding: 20px 0;\n    font-size: 24px;\n}\n.thirdColumn {\n    min-width: 150px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 25%;\n    padding: 20px 0;\n    font-size: 24px;\n}\n.bottomPar {\n    font-size: 28px;\n    line-height: 1.6;\n    text-align: center;\n    color: #000;\n    font-weight: 300;\n    margin-top: 100px;\n}\n\n@media screen and (max-width: 960px) {\n    .table {\n        width: 90%;\n        min-width: 350px;\n    }\n    .firstColumn, .secondColumn, .thirdColumn {\n        font-size: 12px;\n        padding: 13px 0;\n        min-width: 0;\n    }\n    .bottomPar {\n        font-size: 18px;\n        margin-top: 40px;\n        padding: 0 16px;\n    }\n}\n.table ul {\n    width: 100%;\n}\n.table ul li {\n    width: 100%;\n}\n.table_first {\n    width: 100%;\n}\n\n\n\n.belbinLabel {\n    display: block;\n    margin-top: 160px;\n    margin-bottom: 50px;\n    padding-bottom: 200px;\n    height: 150px;\n}\n\n.belbinLabel img {   \n    height: 80px;\n}\n\n/*\n.belbinLabel {\n    margin-top: 150px;\n    margin-bottom: 50px;\n    transform: rotate(-6deg);\n    background: url(../../assets/ResultPage/belbinLabel.svg) bottom center;\n}\n\n*/\n\n@media screen and (max-width: 960px) {\n    .belbinLabel {\n        margin-top: 100px;\n        margin-bottom: 30px;\n    }\n\n    .belbinLabel img {   \n        height: 40px;\n    }\n\n}\n@media screen and (max-width: 600px) {\n    .belbinLabel {\n        margin-top: 70px;\n        margin-bottom: 20px;\n    }\n\n    .belbinLabel img {   \n        height: 30px;\n    }\n\n    .shareButton button {\n        width: 80% !important;\n        margin-top: 5px;\n        font-size: 18px !important;\n    }\n\n    .buttonIcon {\n        margin-right: 10px;\n        margin-top: 0px;\n        width: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `resultPage_main__TEQqX`,
	"topStripe": `resultPage_topStripe__fe8c5`,
	"rightStripe": `resultPage_rightStripe__zkcux`,
	"shareButton": `resultPage_shareButton__K+mKz`,
	"buttonIcon": `resultPage_buttonIcon__eLj1B`,
	"table": `resultPage_table__5G8m6`,
	"firstLi": `resultPage_firstLi__qSW94`,
	"bodyLi": `resultPage_bodyLi__98wsG`,
	"firstColumn": `resultPage_firstColumn__yO1CY`,
	"secondColumn": `resultPage_secondColumn__bat1B`,
	"thirdColumn": `resultPage_thirdColumn__tHZNp`,
	"bottomPar": `resultPage_bottomPar__8REit`,
	"table_first": `resultPage_table_first__uTSEl`,
	"belbinLabel": `resultPage_belbinLabel__htLa7`
};
export default ___CSS_LOADER_EXPORT___;
